import { render, staticRenderFns } from "./AnnouncementEditor.vue?vue&type=template&id=1f2a3364&scoped=true&"
import script from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementEditor.vue?vue&type=style&index=0&id=1f2a3364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a3364",
  null
  
)

export default component.exports